import React, { useEffect, useRef, useState } from 'react'
import { Parallax, useParallax } from 'react-scroll-parallax';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import CountUp from 'react-countup';
import salesforceLogo from '../assets/images/salesforce.svg';
import { Helmet } from 'react-helmet';



export default function Home() {

    const parallax = useParallax < HTMLDivElement > ({
        rotateY: [0, 360],
    });

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const [activeDivider, setActiveDivider] = useState('Requirements');

    const handleClick = (divider) => {
        setActiveDivider(divider);
    };

    const [activeService, setActiveService] = useState('Salesforce Sales Cloud');

    const handleServiceClick = (service) => {
        setActiveService(service);
    };

    const swiperSettings = {
        modules: [Navigation],
        spaceBetween: 10,
        slidesPerView: 1,
        navigation: true,
    };

    return (
        <>

            <Helmet prioritizeSeoTags={true}>
                <meta httpEquiv="content-type" content="text/html; charset=utf-8" />
                <meta name="format-detection" content="telephone=no" />
                <title>Top Salesforce Consulting Company : Codezix</title>
                <meta name="viewport" content="width=device-width, initial-scale=1" />

                <meta
                    name="description"
                    content="Codezix is a leading Salesforce consulting company, empowering businesses to optimize their sales, marketing, and customer service with tailored solutions."
                />
                <meta
                    name="keywords"
                    content="Salesforce consulting company, Salesforce development, Salesforce implementation, Salesforce partner, CRM consulting, Codezix"
                />

                {/* 1) Organization + WebSite + WebPage */}
                <script type="application/ld+json">
                    {`
{
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://codezix.com/#organization",
      "url": "https://codezix.com",
      "name": "Codezix",
      "legalName": "Codezix Solutions",
      "logo": {
        "@type": "ImageObject",
        "url": "https://codezix.com/assets/images/logo.webp",
        "width": 250,
        "height": 80
      },
      "image": "https://codezix.com/assets/images/logo.webp",
      "description": "Codezix is a global Salesforce, cloud consulting, and custom application development company helping organizations innovate faster.",
      "email": "info@codezix.com",
      "telephone": "+1-917-730-7436",
      "sameAs": [
        "https://www.linkedin.com/company/codezix",
        "https://www.facebook.com/codezix",
        "https://twitter.com/codezix"
      ]
    },
    {
      "@type": "WebSite",
      "@id": "https://codezix.com/#website",
      "url": "https://codezix.com",
      "name": "Codezix",
      "publisher": {
        "@id": "https://codezix.com/#organization"
      }
    },
    {
      "@type": "WebPage",
      "@id": "https://codezix.com/#webpage",
      "url": "https://codezix.com",
      "inLanguage": "en-US",
      "name": "Top Salesforce Consulting Company : Codezix",
      "isPartOf": {
        "@id": "https://codezix.com/#website"
      },
      "description": "Codezix is a leading Salesforce consulting company, empowering businesses to optimize their sales, marketing, and customer service with tailored solutions."
    }
  ]
}
    `}
                </script>

                {/* 2) Service schema */}
                <script type="application/ld+json">
                    {`
{
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Salesforce Consulting & Implementation Services",
  "provider": {
    "@type": "Organization",
    "@id": "https://codezix.com/#organization",
    "name": "Codezix"
  },
  "description": "Codezix provides end-to-end Salesforce consulting, implementation, customization, integration, and support services to help businesses scale their CRM and digital transformation initiatives.",
  "url": "https://codezix.com",
  "mainEntityOfPage": "https://codezix.com",
  "areaServed": "Global",
  "serviceType": [
    "Salesforce Consulting",
    "Salesforce Implementation",
    "Salesforce Development",
    "Salesforce Integration",
    "Salesforce Customization",
    "Salesforce Maintenance & Support"
  ]
}
    `}
                </script>

                {/* 3) FAQPage schema */}
                <script type="application/ld+json">
                    {`
{
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What Salesforce services does Codezix provide?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Codezix covers everything Salesforce—CRM setup, custom app development, integration, migration, and support. You get the whole package."
      }
    },
    {
      "@type": "Question",
      "name": "How many Salesforce professionals does Codezix have?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Our team includes over 30 certified Salesforce pros and consultants."
      }
    },
    {
      "@type": "Question",
      "name": "How many Salesforce projects has Codezix completed?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "We’ve delivered more than 50 Salesforce projects, start to finish."
      }
    },
    {
      "@type": "Question",
      "name": "Which Salesforce Clouds does Codezix work with?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "We know our way around Sales Cloud, Service Cloud, Marketing Cloud, and we build custom Salesforce apps too."
      }
    },
    {
      "@type": "Question",
      "name": "Can Codezix help with Salesforce in different geographies?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Absolutely. We handle Salesforce consulting and development worldwide, with dedicated services for multiple regions."
      }
    },
    {
      "@type": "Question",
      "name": "What makes Codezix a trusted Salesforce partner?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "We’ve got deep Salesforce know-how, certified experts, and a solid track record—over 50 successful projects. You can count on us for reliable, scalable solutions."
      }
    }
  ]
}
    `}
                </script>

                {/* 4) Postal address – separate block (Chicago office) */}
                <script type="application/ld+json">
                    {`
{
  "@context": "https://schema.org",
  "@type": "PostalAddress",
  "streetAddress": "222 W Merchandise Mart Plaza Floor 12 Suite 1212",
  "addressLocality": "Unites States",
  "addressRegion": "IL",
  "postalCode": "60654",
  "addressCountry": "US",
  "telephone": "+1-917-730-7436"
}
    `}
                </script>
            </Helmet>



            <div className='salesforce-banner-section bottom'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-7'>
                            <div className='salesforce-banner-left top'>
                                <h1 id="TransformYourSaleHead" className="mt-4 mt-lg-0">
                                    Transform
                                    <img
                                        src={salesforceLogo}
                                        style={{ display: 'inline-block', width: '150px' }}
                                        loading="lazy"
                                        className="wp-post-0 wp-image-113231"
                                        alt="Salesforce Logo"
                                    />
                                    <span className='sub-decorate'>Performance With</span>
                                    <span className="decorated-banner-text" id="homeContainer">
                                        Our Expertise
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            viewBox="0 0 750 100"
                                            width="750"
                                            height="100"
                                            preserveAspectRatio="xMidYMid meet"
                                            style={{ width: '100%', height: '100%' }}
                                        >
                                            <defs>
                                                <clipPath id="__lottie_element_2">
                                                    <rect width="750" height="100" x="0" y="0"></rect>
                                                </clipPath>
                                            </defs>
                                            <g clipPath="url(#__lottie_element_2)">
                                                <g transform="matrix(1,0,0,1,375,50)" opacity="1">
                                                    <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                                                        <path
                                                            strokeLinecap="round"
                                                            strokeLinejoin="miter"
                                                            fillOpacity="0"
                                                            stroke="rgb(241,97,173)"
                                                            strokeOpacity="1"
                                                            strokeWidth="11"
                                                            d="M-359,13 C-359,13 -192,-67 353,7"
                                                        />
                                                    </g>
                                                </g>
                                            </g>
                                        </svg>
                                    </span>
                                </h1>

                                {/* <div className='banner-button'>
                                    <Link to="/contact"><button>Schedule A Call With Experts</button></Link>
                                </div> */}
                                <div className="consulting-button">
                                    <Link to="/contact"><button>Schedule A Call With Experts <i class="fa fa-arrow-right" aria-hidden="true"></i></button></Link>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-5'>
                            <div className='salesforce-banner-right'>
                                <img src={require('../assets/images/banner-check.webp')} alt='' />
                            </div>
                        </div>
                    </div>

                    <div class="pt-5">

                        <div class="awards">
                            <div class="hic-award d-flex align-items-center justify-content-md-start justify-content-center flex-wrap flex-lg-nowrap">
                                {/* <div class="award-items-img d-none d-lg-block">
                                    <img width="93" height="165" src={require('../assets/images/left-bar.webp')} alt="image of _322132" class="wp-post-0 wp-image-23098" />
                                </div> */}
                                <div class="award-items">
                                    <img src={require('../assets/images/award/part-1.webp')} alt="image of _322133" class="wp-post-0 wp-image-61560" />
                                </div>
                                <div class="award-items">
                                    <img src={require('../assets/images/award/part-2.webp')} alt="image of _322133" class="wp-post-0 wp-image-61560" />                                </div>
                                <div class="award-items">
                                    <img src={require('../assets/images/award/part-3.webp')} alt="image of _322133" class="wp-post-0 wp-image-61560" />                                </div>
                                <div class="award-items">
                                    <img src={require('../assets/images/award/part-4.webp')} alt="image of _322133" class="wp-post-0 wp-image-61560" />                                </div>
                                <div class="award-items">
                                    <img src={require('../assets/images/award/part-5.webp')} alt="image of _322133" class="wp-post-0 wp-image-61560" />                                </div>
                                <div class="award-items">
                                    <img src={require('../assets/images/award/part-6.webp')} alt="image of _322133" class="wp-post-0 wp-image-61560" />                                </div>
                                <div class="award-items">
                                    <img src={require('../assets/images/award/part-7.webp')} alt="image of _322133" class="wp-post-0 wp-image-61560" />                                </div>
                                <div class="award-items">
                                    <img src={require('../assets/images/award/part-8.webp')} alt="image of _322133" class="wp-post-0 wp-image-61560" />                                </div>

                                {/* <div class="award-items d-none d-lg-block award-right">
                                    <img width="93" height="165" src={require('../assets/images/left-bar.webp')} alt="image of _322133" />
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='staff-agumentation mt-5'>
                <div className='container'>
                    <h2 class="homeOtherTitle text-center">Build a <span>Powerhouse Team </span> and unlock <br />limitless potential</h2>
                    <div class="row mt-5">
                        <div class="col-lg-6 order-2 order-lg-2 my-auto">
                            <div class="it-card mb-4">
                                <div class="row">
                                    <div class="col-md-5">
                                        <figure class="mb-0">
                                            <img src={require('../assets/images/staff-1.webp')} alt='' class="w-100" />
                                        </figure>
                                    </div>
                                    <div class="col-md-7 my-auto mt-4 mt-xl-0">
                                        <h3 class="fw-bold h2">
                                            Empower Your Team: Augment Your IT Staff
                                        </h3>
                                        <p class="prose-lg">
                                            Scale your Salesforce team with our top-notch staff augmentation services
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="hire-card mb-4 mb-lg-0">
                                <div class="row">
                                    <div class="col-md-5">
                                        <figure class="mb-0">
                                            <img src={require('../assets/images/hire-salesforce.webp')} alt='' class="w-100 " />
                                        </figure>
                                    </div>
                                    <div class="col-md-7 my-auto mt-4 mt-xl-0">
                                        <h3 class="fw-bold h2">
                                            Build Your Team: Add Our Salesforce Developers for Success
                                        </h3>
                                        <p class="prose-lg">
                                            Have a Project in mind? <br /> Get the most out of Salesforce with our experts
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 h-auto order-1 order-lg-1 mb-4 mb-lg-0">
                            <div class="project-card py-5">
                                <div class="card p-2 rounded-pill border-0">
                                    <div class="row search-bar">
                                        <div className='col-md-8 col-8'>
                                            <div className='search-para laptop-search-bar'>Top Salesforce Consulting Company in <strong>US</strong></div>
                                            <div className='search-para mobile-search-bar'>Top Salesforce Consulting...</div>
                                        </div>
                                        <div className='col-md-4 col-4'>
                                            <div className='search-img-right'>
                                                <img src={require('../assets/images/about/mike-google.webp')} alt='' />
                                                <img src={require('../assets/images/about/camera-google.webp')} alt='' />
                                                <img src={require('../assets/images/about/google-search.webp')} alt='' />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <figure class="mb-0">
                                    <img width="585" height="227" src={require('../assets/images/sales-services.webp')} loading="lazy" alt='' class="w-100 mt-3 wp-image-101646" />
                                </figure>
                                <h3 class="fw-bold display-6 pt-4">Let's get you started today</h3>
                                <p class="prose-lg">
                                    Choose the Best Salesforce Consulting company now!
                                </p>
                                {/* <div class="text-end mt-4">
                                    <Link class="btn px-3 rounded-pill btn-lg learnBtn" to="/contact">Contact Us</Link>
                                </div> */}
                                <div className="consulting-button">
                                    <Link to="/contact"><button>Contact Us <i class="fa fa-arrow-right" aria-hidden="true"></i></button></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <section class="whyChoose top_padding bottom">
                <div class="container">
                    <div class="headingText">
                        <h2><b>All in One <br /> <span>Salesforce Services</span></b></h2>
                        <p className='wow fadeUp prose-lg'>We offer complete Salesforce CRM solutions to support all your business operations. With our expertise and experience, we help your company fully leverage Salesforce to its maximum potential.</p>
                    </div>
                    <div className='row top_padding'>
                        <div className='col-lg-4'>
                            <div className='row'>
                                <div className='services-item-box'>
                                    <div
                                        className={`service-item1 ${activeService === 'Salesforce Sales Cloud' ? 'active' : ''}`}
                                        onClick={() => handleServiceClick('Salesforce Sales Cloud')}
                                    >
                                        <p className='prose-lg'>Salesforce Sales Cloud</p>
                                    </div>
                                    <div
                                        className={`service-item1 ${activeService === 'Salesforce Service Cloud' ? 'active' : ''}`}
                                        onClick={() => handleServiceClick('Salesforce Service Cloud')}
                                    >
                                        <p className='prose-lg'>Salesforce Service Cloud</p>
                                    </div>
                                    <div
                                        className={`service-item1 ${activeService === 'Salesforce Marketing Cloud' ? 'active' : ''}`}
                                        onClick={() => handleServiceClick('Salesforce Marketing Cloud')}
                                    >
                                        <p className='prose-lg'>Salesforce Marketing Cloud</p>
                                    </div>
                                    <div
                                        className={`service-item1 ${activeService === 'Salesforce CPQ' ? 'active' : ''}`}
                                        onClick={() => handleServiceClick('Salesforce CPQ')}
                                    >
                                        <p className='prose-lg'>Salesforce CPQ</p>
                                    </div>
                                    <div
                                        className={`service-item1 ${activeService === 'Salesforce Health Cloud' ? 'active' : ''}`}
                                        onClick={() => handleServiceClick('Salesforce Health Cloud')}
                                    >
                                        <p className='prose-lg'>Salesforce Health Cloud</p>
                                    </div>
                                    <div
                                        className={`service-item1 ${activeService === 'Salesforce Experience Cloud' ? 'active' : ''}`}
                                        onClick={() => handleServiceClick('Salesforce Experience Cloud')}
                                    >
                                        <p className='prose-lg'>Salesforce Experience Cloud</p>
                                    </div>
                                    <div
                                        className={`service-item1 ${activeService === 'Salesforce Plateform' ? 'active' : ''}`}
                                        onClick={() => handleServiceClick('Salesforce Plateform')}
                                    >
                                        <p className='prose-lg'>Salesforce Plateform</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-8'>
                            <div className='services-details-right'>
                                {activeService === 'Salesforce Sales Cloud' &&
                                    <>
                                        <div className='details-items'>
                                            <img src={require('../assets/images/services/sales-cloud.webp')} alt='' />
                                            <h3 className='mt-5'>Salesforce Sales Cloud</h3>
                                            <p className='wow fadeUp prose-lg'>Codezix provides Salesforce Sales Cloud Consultant Services, allowing you to fully customize the large Salesforce CRM platform to meet your specific company requirements and help you to achieve your business goals.</p>
                                            {/* <div className='read-more-button'>
                                                <Link to="/salesforce/sales-cloud"><button>Learn More</button></Link>
                                            </div> */}

                                            <div class="ChooseList">
                                                <ul className='ml-3'>
                                                    <li><span><i class="fas fa-check"></i></span> Custom Solution as per the Requirement
                                                    </li>
                                                    <li><span><i class="fas fa-check"></i></span> Lead Management
                                                    </li>
                                                    <li><span><i class="fas fa-check"></i></span> Process Automation
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="consulting-button mt-3">
                                                <Link to="/salesforce/sales-cloud"><button>Learn More <i class="fa fa-arrow-right" aria-hidden="true"></i></button></Link>
                                            </div>
                                        </div>
                                    </>
                                }
                                {activeService === 'Salesforce Service Cloud' &&
                                    <>
                                        <>
                                            <div className='details-items'>
                                                <img src={require('../assets/images/services/service-cloud.webp')} alt='' />
                                                <h3 className='mt-5'>Salesforce Service Cloud</h3>
                                                <p className='wow fadeUp prose-lg'>Salesforce Service Cloud consultant services are provided by Codezix, enabling you to fully customize the powerful Salesforce CRM platform to meet your unique business needs and help you achieve your goals.</p>
                                                <div className='row'>
                                                    <div className='col-md-6'>
                                                        <div class="ChooseList">
                                                            <ul className='ml-3'>
                                                                <li><span><i class="fas fa-check"></i></span> Improved Productivity</li>
                                                                <li><span><i class="fas fa-check"></i></span> Increase Revenue</li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <div class="ChooseList">
                                                            <ul className='ml-3'>
                                                                <li><span><i class="fas fa-check"></i></span> Data Security</li>
                                                                <li><span><i class="fas fa-check"></i></span> Customer Interaction</li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="consulting-button mt-3">
                                                    <Link to="/salesforce/service-cloud"><button>Learn More <i class="fa fa-arrow-right" aria-hidden="true"></i></button></Link>
                                                </div>
                                            </div>
                                        </>
                                    </>
                                }
                                {activeService === 'Salesforce Marketing Cloud' &&
                                    <>
                                        <div className='details-items'>
                                            <img src={require('../assets/images/services/marketing-cloud.webp')} alt='' />
                                            <h3 className='mt-5'>Salesforce Marketing Cloud</h3>
                                            <p className='wow fadeUp prose-lg'>Salesforce Marketing Cloud is a comprehensive digital marketing platform that automates marketing efforts across email, social media, mobile apps, SMS, websites, and more. Organizations choose Salesforce Marketing Cloud (SFMC) to unify all their marketing channels in a single platform. This enables marketers to send personalized messages through the most effective channels, at the optimal time, ensuring greater engagement and impact.</p>
                                            <div className='row'>
                                                <div className='col-md-6'>
                                                    <div class="ChooseList">
                                                        <ul className='ml-3'>
                                                            <li><span><i class="fas fa-check"></i></span> Email marketing</li>
                                                            <li><span><i class="fas fa-check"></i></span> Content creation</li>
                                                            <li><span><i class="fas fa-check"></i></span> Mobile push notifications</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div class="ChooseList">
                                                        <ul className='ml-3'>
                                                            <li><span><i class="fas fa-check"></i></span> Social media marketing</li>
                                                            <li><span><i class="fas fa-check"></i></span> Campaign automation</li>
                                                            <li><span><i class="fas fa-check"></i></span> Online advertising</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="consulting-button mt-3">
                                                <Link to="/salesforce/marketing-cloud"><button>Learn More <i class="fa fa-arrow-right" aria-hidden="true"></i></button></Link>
                                            </div>
                                        </div>
                                    </>
                                }
                                {activeService === 'Salesforce CPQ' &&
                                    <>
                                        <div className='details-items'>
                                            <img src={require('../assets/images/services/cpq.webp')} alt='' />
                                            <h3 className='mt-5'>Salesforce CPQ</h3>
                                            <p className='wow fadeUp prose-lg'> Salesforce CPQ (Configure, Price, Quote) services offered by Codezix are designed to help businesses automate and streamline the process of generating accurate price quotes for complex and customizable products or services. This solution simplifies pricing configurations, ensuring quick and error-free quotes, and enhances efficiency throughout the sales cycle.</p>
                                            <div class="ChooseList">
                                                <ul className='ml-3'>
                                                    <li><span><i class="fas fa-check"></i></span> Automated and Streamlined Quoting</li>
                                                    <li><span><i class="fas fa-check"></i></span> Accurate Pricing and Discounts</li>
                                                    <li><span><i class="fas fa-check"></i></span> Seamless Integration with Salesforce</li>
                                                </ul>
                                            </div>
                                            <div className="consulting-button mt-3">
                                                <Link to="/salesforce/cpq"><button>Learn More <i class="fa fa-arrow-right" aria-hidden="true"></i></button></Link>
                                            </div>
                                        </div>
                                    </>
                                }
                                {activeService === 'Salesforce Health Cloud' &&
                                    <>
                                        <div className='details-items'>
                                            <img src={require('../assets/images/services/health-cloud.webp')} alt='' />
                                            <h3 className='mt-5'>Salesforce Health Cloud</h3>
                                            <p className='wow fadeUp prose-lg'> Codezix offers expert guidance, support, and effective solutions to organizations facing challenges that cannot be resolved internally.</p>
                                            <div class="ChooseList">
                                                <ul className='ml-3'>
                                                    <li><span><i class="fas fa-check"></i></span> Enhanced Care for Patient Relationships</li>
                                                    <li><span><i class="fas fa-check"></i></span>Boosted R&D and Innovations </li>
                                                    <li><span><i class="fas fa-check"></i></span> Enhanced Customer Service</li>
                                                </ul>
                                            </div>
                                            <div className="consulting-button mt-3">
                                                <Link to="/"><button>Learn More <i class="fa fa-arrow-right" aria-hidden="true"></i></button></Link>
                                            </div>
                                        </div>
                                    </>
                                }
                                {activeService === 'Salesforce Experience Cloud' &&
                                    <>
                                        <div className='details-items'>
                                            <img src={require('../assets/images/services/experience-cloud.webp')} alt='' />
                                            <h3 className='mt-5'>Salesforce Experience Cloud</h3>
                                            <p className='wow fadeUp prose-lg'> Leveraging our Salesforce expertise, we help you unlock the full potential of the #1 CRM. We understand your complex challenges and craft innovative, scalable solutions to help you overcome any obstacles and drive success.</p>
                                            <div class="ChooseList">
                                                <ul className='ml-3'>
                                                    <li><span><i class="fas fa-check"></i></span> Experience Cloud Assistance</li>
                                                    <li><span><i class="fas fa-check"></i></span>Personalization through Data Integration </li>
                                                    <li><span><i class="fas fa-check"></i></span>Enhanced Security and Transparency</li>
                                                    <li><span><i class="fas fa-check"></i></span>Real-time Order Status Tracking</li>
                                                </ul>
                                            </div>
                                            <div className="consulting-button mt-3">
                                                <Link to="/"><button>Learn More <i class="fa fa-arrow-right" aria-hidden="true"></i></button></Link>
                                            </div>
                                        </div>
                                    </>
                                }
                                {activeService === 'Salesforce Plateform' &&
                                    <>
                                        <div className='details-items'>
                                            <img src={require('../assets/images/services/plateform.webp')} alt='' />
                                            <h3 className='mt-5'>Salesforce Platform</h3>
                                            <p className='wow fadeUp prose-lg'> As an elite Salesforce Consulting Partner, we possess the highest level of Salesforce expertise. However, success goes beyond technology. Leading brands understand that business is ultimately about putting people first.</p>
                                            <div class="ChooseList">
                                                <ul className='ml-3'>
                                                    <li><span><i class="fas fa-check"></i></span> Customer Actions are Monitored</li>
                                                    <li><span><i class="fas fa-check"></i></span> Automation Tools</li>
                                                    <li><span><i class="fas fa-check"></i></span> Customer Interaction</li>
                                                </ul>
                                            </div>
                                            <div className="consulting-button mt-3">
                                                <Link to="/"><button>Learn More <i class="fa fa-arrow-right" aria-hidden="true"></i></button></Link>
                                            </div>
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="salesforce-about py-5">
                <div className="container">
                    <div className="hic-home-padding-15">
                        <h2 className="text-white mb-4 about-heading">
                            Know More About Codezix In Details
                        </h2>
                        <p className="text-white prose-lg">
                            Codezix isn't just any Salesforce consulting company – we're a team of Salesforce and business experts passionate about delivering agile, creative solutions to meet your unique CRM needs.
                        </p>
                        <p className="text-white prose-lg">
                            As a trusted Salesforce Crest partner, we believe in collaborating closely with our clients to craft the perfect systems and processes that align with their business goals. Our team of experienced specialists understands that customer relationships and system processes are crucial to your success, which is why we're committed to providing you with the best Salesforce consulting services to help you grow and reach more clients. With Codezix as your partner, you can focus on what matters – driving your business forward.
                        </p>
                    </div>

                    <div className="container py-4">

                        <div className="row">
                            <div className="col-12 col-md-6 col-lg-4 mb-0 text-center">
                                <div className='experience-item mt-3'>
                                    <Link to="/" id="about-h2">
                                        <h3 className="pc-fontsize pt-3 px-2">200+</h3>
                                        <span className="sub-about text-center">Projects Delivered</span>
                                    </Link>
                                </div>
                            </div>

                            <div className="col-12 col-md-6 col-lg-4 mb-0 text-center">
                                <div className='experience-item mt-3'>
                                    <Link to="/" id="about-h2">
                                        <h3 className="pc-fontsize pt-3 px-2">7 Apps</h3>
                                        <span className="sub-about text-center">On Appexchange</span>
                                    </Link>
                                </div>
                            </div>

                            <div className="col-12 col-md-6 col-lg-4 mb-0 text-center">
                                <div className='experience-item mt-3'>
                                    <Link to="/" id="about-h2">
                                        <h3 className="pc-fontsize pt-3 px-2">200+</h3>
                                        <span className="sub-about text-center">Creative nerds under the roof</span>
                                    </Link>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

            <div className='testimonial-sales top_padding'>
                <div className='container'>
                    <div className='heading-section text-center'>
                        <h2>Our Trusted Testimonial</h2>
                    </div>
                    <div className='row mt-4'>
                        <Swiper {...swiperSettings}
                            breakpoints={{
                                640: {
                                    slidesPerView: 1,
                                    spaceBetween: 10,
                                },
                                768: {
                                    slidesPerView: 2,
                                    spaceBetween: 30,
                                },
                                1024: {
                                    slidesPerView: 2.5,
                                    spaceBetween: 30,
                                },
                                1440: {
                                    slidesPerView: 3,
                                    spaceBetween: 10,
                                },
                            }}
                            autoplay={{
                                delay: 2500,
                                disableOnInteraction: false,
                            }}
                            pagination={{
                                clickable: true,
                            }}
                            navigation={true}
                            modules={[Pagination, Autoplay, Navigation]}
                            className="testimonialSwiper-client"
                        >
                            <SwiperSlide>
                                <div className='client-say-item'>
                                    <iframe
                                        width="100%"
                                        height="370"
                                        src="https://www.youtube.com/embed/dR8t0r8sYJQ?si=N3H2IXYLGIWdillb"
                                        title="YouTube video player"
                                        frameborder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        referrerpolicy="strict-origin-when-cross-origin"
                                        allowfullscreen>

                                    </iframe>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='client-say-item'>
                                    <iframe
                                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen
                                        class="lazy entered loaded"
                                        data-src="https://www.youtube.com/embed/7_OhPkg9Wx4"
                                        frameborder="0"
                                        height="370"
                                        scrolling="no"
                                        width="100%"
                                        src="https://www.youtube.com/embed/7_OhPkg9Wx4"
                                        title="video intro"
                                    ></iframe>

                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                <div className='client-say-item'>
                                    <iframe
                                        width="100%"
                                        height="370"
                                        src="https://www.youtube.com/embed/dR8t0r8sYJQ?si=N3H2IXYLGIWdillb"
                                        title="YouTube video player"
                                        frameborder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        referrerpolicy="strict-origin-when-cross-origin"
                                        allowfullscreen>

                                    </iframe>

                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='client-say-item'>
                                    <iframe
                                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen
                                        class="lazy entered loaded"
                                        data-src="https://www.youtube.com/embed/7_OhPkg9Wx4"
                                        frameborder="0"
                                        height="370"
                                        scrolling="no"
                                        width="100%"
                                        src="https://www.youtube.com/embed/7_OhPkg9Wx4"
                                        title="video intro"
                                    ></iframe>

                                </div>
                            </SwiperSlide>
                            {/* <SwiperSlide className="col-lg-4 ">
                                <iframe
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowfullscreen
                                    frameborder="0"
                                    height="350"
                                    scrolling="no"
                                    width="100%"
                                    src="https://www.youtube.com/embed/YiBgaCrRZDA"
                                    title="video intro"
                                ></iframe>
                            </SwiperSlide> */}
                        </Swiper>
                    </div>
                </div>
            </div>

            <div className='about-relationships'>
                <div className='container'>
                    <div className='heading-section text-center'>
                        <h2>Enduring Relationships</h2>
                    </div>
                    <div className='row'>
                        <div className='col-lg-3 col-md-3 col-6 mt-3'>
                            <div class="partner-item">
                                <img src={require('../assets/images/client/part-1.webp')} alt="" />
                            </div>
                        </div>
                        <div className='col-lg-3 col-md-3 col-6 mt-3'>
                            <div className='partner-item'>
                                <img src={require('../assets/images/client/part-2.webp')} alt='' />
                            </div>
                        </div>
                        <div className='col-lg-3 col-md-3 col-6 mt-3'>
                            <div className='partner-item'>
                                <img src={require('../assets/images/client/part-3.webp')} alt='' />
                            </div>
                        </div>
                        <div className='col-lg-3 col-md-3 col-6 mt-3'>
                            <div className='partner-item'>
                                <img src={require('../assets/images/client/part-4.webp')} alt='' />
                            </div>
                        </div>
                        <div className='col-lg-3 col-md-3 col-6 mt-3'>
                            <div className='partner-item'>
                                <img src={require('../assets/images/client/part-5.webp')} alt='' />
                            </div>
                        </div>
                        <div className='col-lg-3 col-md-3 col-6 mt-3'>
                            <div className='partner-item'>
                                <img src={require('../assets/images/client/part-6.webp')} alt='' />
                            </div>
                        </div>
                        <div className='col-lg-3 col-md-3 col-6 mt-3'>
                            <div className='partner-item'>
                                <img src={require('../assets/images/client/part-7.webp')} alt='' />
                            </div>
                        </div>
                        <div className='col-lg-3 col-md-3 col-6 mt-3'>
                            <div className='partner-item'>
                                <img src={require('../assets/images/client/part-8.webp')} alt='' />
                            </div>
                        </div>
                        <div className='col-lg-3 col-md-3 col-6 mt-3'>
                            <div className='partner-item'>
                                <img src={require('../assets/images/client/part-9.webp')} alt='' />
                            </div>
                        </div>
                        <div className='col-lg-3 col-md-3 col-6 mt-3'>
                            <div className='partner-item'>
                                <img src={require('../assets/images/client/part-10.webp')} alt='' />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='engineering-product top'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-6 mt-4'>
                            <div className='engineering-product-item'>
                                <img src={require('../assets/images/digital-engineering.webp')} alt='' />
                                <div className='engineering-product-content'>
                                    <h3>Digital Engineering</h3>
                                    <p className='wow fadeUp prose-lg'>Our product engineering services focuses on product design & innovation, development, and product management services. We combine domain and technology expertise to drive real business outcomes.</p>
                                    <div className="consulting-button">
                                        <Link to="/contact"><button>Get In Touch <i class="fa fa-arrow-right" aria-hidden="true"></i></button></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-6 mt-4'>
                            <div className='engineering-product-item'>
                                <img src={require('../assets/images/Quality.webp')} alt='' />
                                <div className='engineering-product-content'>
                                    <h3>Quality Assurance</h3>
                                    <p className='wow fadeUp prose-lg'>Our testing experts specialize in automation and manual testing, ensuring the quality of your application’s functionality, integrations, performance, security, and more. We quickly validate every aspect of your project.</p>
                                    <div className="consulting-button">
                                        <Link to="/contact"><button>Get In Touch <i class="fa fa-arrow-right" aria-hidden="true"></i></button></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='team-projects mt-4'>
                <div className='container'>
                    <div className='explore-heading mt-4'>
                        <h2 className='text-white'>Let's Talk in Terms of Team Projects</h2>
                        {/* <div class="divider-wrapper small"></div> */}
                    </div>
                    <div className='row top bottom'>
                        <div className='col-lg-4 col-sm-6 mt-3'>
                            <div className='team-project-item'>
                                <img src={require('../assets/images/happy.png')} alt='' />
                                <h3>250+</h3>
                                <p>Happy Clients</p>
                            </div>
                        </div>
                        <div className='col-lg-4 col-sm-6 mt-3'>
                            <div className='team-project-item'>
                                <img src={require('../assets/images/expert-1.webp')} alt='' />
                                <h3>50+</h3>
                                <p>IT Professionals</p>
                            </div>
                        </div>
                        <div className='col-lg-4 col-sm-6 mt-3'>
                            <div className='team-project-item'>
                                <img src={require('../assets/images/verified.webp')} alt='' />
                                <h3>100+</h3>
                                <p>Successful Projects</p>
                            </div>
                        </div>
                        <div className='col-lg-4 col-sm-6 mt-3'>
                            <div className='team-project-item'>
                                <img src={require('../assets/images/salesforce-experience-cloud.webp')} alt='' />
                                <h3>10+</h3>
                                <p>Years of Experience</p>
                            </div>
                        </div>
                        <div className='col-lg-4 col-sm-6 mt-3'>
                            <div className='team-project-item'>
                                <img src={require('../assets/images/retention.webp')} alt='' />
                                <h3>90+</h3>
                                <p>Client Retention Rate</p>
                            </div>
                        </div>
                        <div className='col-lg-4 col-sm-6 mt-3'>
                            <div className='team-project-item'>
                                <img src={require('../assets/images/office.webp')} alt='' />
                                <h3>2+</h3>
                                <p>Global Offices</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <section class="whyChoose mt-4 bottom">
                <div class="container">
                    <div class="headingText">
                        <h2><b>Why <br /> <span>Choose Codezix</span></b></h2>
                        <p className='wow fadeUp prose-lg'>We at Codezix have been providing enormous consulting &amp; services to many businesses as we have over more than 12 years of experience. </p>
                    </div>
                    <div class="row chooseRow">
                        <div className='row'>
                            <div className='col-md-6'>
                                <div class="ChooseList">
                                    <ul>
                                        <li><span><i class="fas fa-check"></i></span>Top Salesforce Consulting & Development.
                                        </li>
                                        <li><span><i class="fas fa-check"></i></span> 30+ certified professionals and consultants.
                                        </li>
                                        <li><span><i class="fas fa-check"></i></span> 50+ Salesforce projects delivered.
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className='col-md-6'>
                                <div class="ChooseList">
                                    <ul>
                                        <li><span><i class="fas fa-check"></i></span> Fast delivery with high-qualities services.
                                        </li>
                                        <li><span><i class="fas fa-check"></i></span> 100% in-house code.
                                        </li>

                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="choodeCard">
                                <span><i class="fa fa-check"></i></span>
                                <br />
                                <h3>Our Mission</h3>
                                <p className="prose-lg">Codezix aims to seamlessly integrate client data through a streamlined process, helping both you and your customers to the achieve and your business goals.
                                </p>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="choodeCard">
                                <span><i class="fa fa-check"></i></span>
                                <br />
                                <h3>Client-Focused Approach</h3>
                                <p className="prose-lg">Codezix communication prioritization such as customer experiences, interaction, and technology helps you and your customer achieve solution of any problem and convert.
                                </p>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="choodeCard">
                                <span><i class="fas fa-check"></i></span>
                                <br />
                                <h3>Our Principles</h3>
                                <p className="prose-lg"> Our desire is to provide greatest solutions to our clients by boosting their company operations use of technology, based on principles rapid delivery, high-quality service.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className='mark-made-section top'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-5'>
                            <div className='mark-made-left'>
                                <div className='explore-heading text-left'>
                                    <h2>About Codezix</h2>
                                    <p className='prose-lg'>Welcome to Codezix, your trusted partner in optimizing customer relationships. We provide cutting-edge CRM solutions to help you build stronger connections, foster loyalty, and drive growth. Our experienced team is dedicated to streamlining customer interactions.</p>
                                    <div className='made-mark-button'>
                                        <div className="inner-about-button mb-3">
                                            <Link to="/contact"><button>Get In Touch <i class="fa fa-arrow-right" aria-hidden="true"></i></button></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className='col-lg-7'>
                            <div className='mark-made-right'>
                                <div className='row'>
                                    <div className='col-lg-4 col-md-6 mt-2'>
                                        <div className='mark-item'>
                                            <h3><CountUp start={0} end={50} duration={10} suffix="+" /></h3>
                                            <p className='wow fadeUp'>Employees</p>
                                        </div>
                                    </div>
                                    <div className='col-lg-4 col-md-6 mt-2'>
                                        <div className='mark-item'>
                                            <h3> <CountUp start={0} end={4.85} duration={15} suffix="/5" decimals={2} /></h3>
                                            <p className='wow fadeUp'>CSAT</p>
                                        </div>
                                    </div>
                                    <div className='col-lg-4 col-md-6 mt-2'>
                                        <div className='mark-item'>
                                            <h3><CountUp start={0} end={100} duration={10} suffix="+" /></h3>
                                            <p className='wow fadeUp'>Global Clients</p>
                                        </div>
                                    </div>

                                    <div className='col-lg-4 col-md-6 mt-2'>
                                        <div className='mark-item'>
                                            <h3><CountUp end={1255} duration={8} suffix="+" /></h3>
                                            <p className='wow fadeUp'>Salesforce Certifications</p>
                                        </div>
                                    </div>
                                    <div className='col-lg-4 col-md-6 mt-2'>
                                        <div className='mark-item'>
                                            <h3><CountUp end={10} duration={8} suffix="+" /></h3>
                                            <p className='wow fadeUp'>Fortune 1000 Clients</p>
                                        </div>
                                    </div>
                                    <div className='col-lg-4 col-md-6 mt-2'>
                                        <div className='mark-item'>
                                            <h3><CountUp end={5} duration={10} suffix="+" /></h3>
                                            <p className='wow fadeUp'>Global Sales and Delivery</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <section className="blog-section">
                <div className="container">
                    <div className='explore-heading mb-4'>
                        <h2>Our Blogs</h2>
                        <div class="divider-wrapper small"></div>
                    </div>
                    <div className="row">
                        <Swiper
                            breakpoints={{
                                640: {
                                    slidesPerView: 1,
                                    spaceBetween: 10,
                                },
                                768: {
                                    slidesPerView: 2,
                                    spaceBetween: 30,
                                },
                                1024: {
                                    slidesPerView: 3,
                                    spaceBetween: 30,
                                },
                            }}
                            autoplay={{
                                delay: 2500,
                                disableOnInteraction: false,
                            }}
                            pagination={{
                                clickable: true,
                            }}
                            modules={[Pagination, Autoplay]}
                            className="testimonialSwiper-blog-service"
                        >
                            <SwiperSlide>
                                <div className="blog-container">
                                    <a href="https://www.winklix.com/blog/15-future-ready-ai-app-ideas-for-2025-that-entrepreneurs-cant-miss/" target="_blank">
                                        <div className="blog-img">
                                            <img src="https://www.winklix.com/blog/wp-content/uploads/2024/10/create-app-using-AIML-1.png" alt="AI Development Services " />
                                        </div><br />
                                        <h3>15 Future-Ready AI App Ideas for 2025 That</h3>
                                        <p>Assume that an AI-driven financial advisor is critically....</p>

                                        <div className="blog-read-more">
                                            <button>Read More&nbsp;<i class="fa fa-arrow-right"></i></button>
                                        </div>
                                    </a>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className="blog-container">
                                    <a href="https://www.winklix.com/blog/exploring-ai-and-human-intelligence-augmentation/" target="_blank">
                                        <div className="blog-img">
                                            <img src="https://www.winklix.com/blog/wp-content/uploads/2024/06/Human-aware-AI-hero.png" alt="AI development company" />
                                        </div><br />
                                        <h3>Exploring AI and Human Intelligence Augmentation</h3>
                                        <p>In many businesses, AI is now a key driver....</p>

                                        <div className="blog-read-more">
                                            <button>Read More&nbsp;<i class="fa fa-arrow-right"></i></button>
                                        </div>
                                    </a>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className="blog-container">
                                    <a href="https://www.winklix.com/blog/15-future-ready-ai-app-ideas-for-2025-that-entrepreneurs-cant-miss/" target="_blank">
                                        <div className="blog-img">
                                            <img src="https://www.winklix.com/blog/wp-content/uploads/2024/10/create-app-using-AIML-1.png" alt="AI Development Services " />
                                        </div><br />
                                        <h3>15 Future-Ready AI App Ideas for 2025 That</h3>
                                        <p>Assume that an AI-driven financial advisor is critically....</p>

                                        <div className="blog-read-more">
                                            <button>Read More&nbsp;<i class="fa fa-arrow-right"></i></button>
                                        </div>
                                    </a>
                                </div>
                            </SwiperSlide>
                        </Swiper>
                    </div>
                </div>
            </section>

            {/* Faq Section  */}
            {/* ============ FAQ SECTION (Codezix Salesforce) ============ */}
            <section className="py-5 py-md-6 bg-light" id="faq">
                <div className="container py-md-4">

                    <div className="row g-5 align-items-start">

                        {/* Left Heading */}
                        <div className="col-md-5">
                            <h2 className="fw-bold display-3 mb-4">
                                Salesforce FAQs <br />
                                <span className="text-primary">About Codezix</span>
                            </h2>
                            <p className="text-muted fs-3">
                                Clear answers to common questions about our Salesforce expertise, global delivery, and service capabilities.
                            </p>
                        </div>

                        {/* Right FAQ Accordion */}
                        <div className="col-12 col-lg-7">
                            <div className="accordion" id="faqAcc">

                                {/* Q1 */}
                                <div className="accordion-item border rounded-3 mb-4 shadow-sm">
                                    <h2 className="accordion-header">
                                        <button
                                            className="accordion-button collapsed fs-3 fw-semibold text-start"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#faq1"
                                        >
                                            What Salesforce services does Codezix provide?
                                        </button>
                                    </h2>
                                    <div id="faq1" className="accordion-collapse collapse" data-bs-parent="#faqAcc">
                                        <div className="accordion-body fs-4 text-muted text-start">
                                            Codezix delivers Salesforce CRM setup, custom app development, integrations,
                                            data migration, automation and support — the full end-to-end solution.
                                        </div>
                                    </div>
                                </div>

                                {/* Q2 */}
                                <div className="accordion-item border rounded-3 mb-4 shadow-sm">
                                    <h2 className="accordion-header">
                                        <button
                                            className="accordion-button collapsed fs-3 fw-semibold text-start"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#faq2"
                                        >
                                            How many Salesforce professionals does Codezix have?
                                        </button>
                                    </h2>
                                    <div id="faq2" className="accordion-collapse collapse" data-bs-parent="#faqAcc">
                                        <div className="accordion-body fs-4 text-muted text-start">
                                            Our team includes 30+ certified Salesforce consultants, developers, and architects.
                                        </div>
                                    </div>
                                </div>

                                {/* Q3 */}
                                <div className="accordion-item border rounded-3 mb-4 shadow-sm">
                                    <h2 className="accordion-header">
                                        <button
                                            className="accordion-button collapsed fs-3 fw-semibold text-start"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#faq3"
                                        >
                                            How many Salesforce projects has Codezix completed?
                                        </button>
                                    </h2>
                                    <div id="faq3" className="accordion-collapse collapse" data-bs-parent="#faqAcc">
                                        <div className="accordion-body fs-4 text-muted text-start">
                                            We have delivered 50+ successful Salesforce projects across multiple industries.
                                        </div>
                                    </div>
                                </div>

                                {/* Q4 */}
                                <div className="accordion-item border rounded-3 mb-4 shadow-sm">
                                    <h2 className="accordion-header">
                                        <button
                                            className="accordion-button collapsed fs-3 fw-semibold text-start"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#faq4"
                                        >
                                            Which Salesforce Clouds does Codezix work with?
                                        </button>
                                    </h2>
                                    <div id="faq4" className="accordion-collapse collapse" data-bs-parent="#faqAcc">
                                        <div className="accordion-body fs-4 text-muted text-start">
                                            We specialize in Sales Cloud, Service Cloud, Marketing Cloud, Experience Cloud,
                                            and full custom Salesforce application development.
                                        </div>
                                    </div>
                                </div>

                                {/* Q5 */}
                                <div className="accordion-item border rounded-3 mb-4 shadow-sm">
                                    <h2 className="accordion-header">
                                        <button
                                            className="accordion-button collapsed fs-3 fw-semibold text-start"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#faq5"
                                        >
                                            Can Codezix support Salesforce projects globally?
                                        </button>
                                    </h2>
                                    <div id="faq5" className="accordion-collapse collapse" data-bs-parent="#faqAcc">
                                        <div className="accordion-body fs-4 text-muted text-start">
                                            Yes — we assist clients globally including UAE/Dubai, Paris, USA, and India,
                                            offering remote and onsite Salesforce delivery.
                                        </div>
                                    </div>
                                </div>

                                {/* Q6 */}
                                <div className="accordion-item border rounded-3 shadow-sm">
                                    <h2 className="accordion-header">
                                        <button
                                            className="accordion-button collapsed fs-3 fw-semibold text-start"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#faq6"
                                        >
                                            What makes Codezix a trusted Salesforce partner?
                                        </button>
                                    </h2>
                                    <div id="faq6" className="accordion-collapse collapse" data-bs-parent="#faqAcc">
                                        <div className="accordion-body fs-4 text-muted text-start">
                                            Certified experts, deep domain experience and a proven track record of 50+ successful
                                            implementations make us a reliable and scalable Salesforce partner.
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>


                    </div>
                </div>
            </section>

        </>
    )
}
